import React from 'react';
import { Button, Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldSelectIsActive, toastSuccess } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { gqlΙnitializeWCPMaterials } from './graphql';
import { useHandleError } from 'shared-pages/services';
import { TiRefresh } from 'react-icons/ti';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    /* if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ name: likeObj }, { notes: likeObj }],
      };
    } */
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.wastereceptionpointId)
      where = { ...where, wastereceptionpointId: values.wastereceptionpointId };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, isGridInForm, refetch, canEdit }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }
  //console.log("filters-init ", initialValues);

  const filters = {
    //searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
  };

  const { handleGraphqlError } = useHandleError('wastereceptionpoint-Materials');
  const [initMaterialsMutation] = useMutation(gqlΙnitializeWCPMaterials);

  function handleInitMaterials(event): void {
    initMaterialsMutation()
      .then((d) => {
        toastSuccess(t('Επιτυχής Ενημέρωση'));
        refetch();
      })
      .catch((error) => {
        handleGraphqlError('mutation-update', error);
      });
  }

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        {/* <FieldInput as={FormCol} name="searchText" label={t('Αναζήτηση')} type="search" /> */}
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} />

        <FormCol className="d-flex align-items-center">
          <Button
            variant="primary"
            className="col-12"
            onClick={handleInitMaterials}
            disabled={!canEdit}
          >
            <TiRefresh size={22} className="mb-1 me-1" />
            Συμπλήρωση όσων Αποβλήτων Λείπουν
          </Button>
        </FormCol>
      </Row>
    </FormFilterCard>
  );
};
